import styled, { css } from 'styled-components'

// Components

import { TableComponents, TableOld } from '@sketch/components'

//Utils
import { breakpoint } from '@sketch/global-styles'

import { ReactComponent as QuestionMarkIcon } from '@sketch/icons/question-mark-16-svg'

// Styles
export const Wrapper = styled.div`
  margin-top: 20px;
`

export const LicenseKey = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`

export const CanceledButton = styled(TableOld.Button)`
  &,
  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.colors.state.negative.A};
  }
`

export const StateCell = styled(TableOld.Cell)``

const cellStyle = css`
  padding: 12px 4px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

export const TableHeader = styled(TableOld.Header)<{ isVisible?: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'table-header-group' : 'none')};

  ${TableOld.HeaderCell} {
    ${cellStyle}
  }
`

export const TableRow = styled(TableOld.Row)`
  ${TableOld.Cell} {
    ${cellStyle}
  }

  ${breakpoint('base', 'sm')`
    display: flex;
    flex-direction: column;
    padding: 16px 0;

    ${StateCell} {
      margin-top: 8px;
    }

    ${TableOld.Cell} {
      padding: 0;
    }
  `}
`

export const QuestionMark = styled(QuestionMarkIcon)`
  width: 17px;
  height: 17px;
  opacity: 0.5;
`

export const TooltipWrapper = styled.div`
  display: inline-block;
`

export const TableWrapper = styled.div`
  ${TableComponents.Table} {
    width: 100%;
  }

  ${breakpoint('base', 'sm')`${css`
    ${TableComponents.TableHeader} {
      display: none;
    }

    ${TableComponents.TableRow} {
      display: flex;
      flex-direction: column;
      padding: 12px;
    }

    ${TableComponents.TableCell} {
      padding: 0;

      :nth-last-child(1) {
        margin-top: 8px;
      }
    }
  `}`}
`
